import { CustomerType } from "../types/shop-cookies";

export function getCustomerType(): CustomerType {
  // use Private as default value
  let customerType = CustomerType.Private;

  if (typeof window !== "undefined") {
    const cookieValue = document.cookie
      .split("; ")
      .find((row) => row.startsWith("CustomerType="))
      ?.split("=")[1];

    if (cookieValue === "Company") customerType = CustomerType.Company;
    else if (cookieValue === "Surgery") customerType = CustomerType.Surgery;
  }
  return customerType;
}
